module.exports = __webpack_public_path__ + "media/images/emblems/Klosters-Serneus_wappen-dd0bf56af0ec3a52acf10dba783bc8c6.svg";